import { FiEdit3 } from "react-icons/fi"
import Button from "../../component/button/button"
import { resolveTaxonomyLabel } from "../../utils/subjectTaxonomy"
import { PreviewSubjectOption, ProcessedQuestionContent } from "./types"

interface QuestionDetailsProps {
  content: ProcessedQuestionContent
  subjects: PreviewSubjectOption[]
  onEdit: () => void
}

const QuestionDetails = ({
  content,
  subjects,
  onEdit,
}: QuestionDetailsProps) => {
  const selectedSubject = subjects.find((item) => item.value === content.subject)

  const getSubjectLabel = (subjectValue: string) =>
    subjects.find((item) => item.value === subjectValue)?.label || subjectValue

  const getTopicLabel = () =>
    resolveTaxonomyLabel(selectedSubject?.topics, content.topic)

  return (
    <div className='right'>
      <h3>Question Details</h3>

      <h4>
        Subject <span>*</span>
      </h4>
      <p>{getSubjectLabel(content.subject)}</p>

      <h4>
        Chapter/Topic <span>*</span>
      </h4>
      <p>{getTopicLabel()}</p>

      <h4>
        Complexity <span>*</span>
      </h4>
      <p className='tag'>{content.complexity}</p>

      <Button
        text='Edit'
        type='secondary'
        icon={<FiEdit3 />}
        onClick={onEdit}
        style={{
          width: "fit-content",
          height: 40,
          gap: 5,
          fontSize: 14,
          padding: "8px 12px",
          marginTop: "auto",
          marginLeft: "auto",
        }}
      />
    </div>
  )
}

export default QuestionDetails
